/** Returns the numeric value of a field validation by type (e.g. 'max_length'), or undefined. */
export function getValidationValue(validations, validationType) {
  var validation = validations === null || validations === void 0 ? void 0 : validations.find(function (rule) {
    return rule.type === validationType;
  });
  if (!validation) return undefined;
  var parsed = typeof validation.value === "number" ? validation.value : parseInt(validation.value, 10);
  return Number.isNaN(parsed) ? undefined : parsed;
}